var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDibk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 340.2 412.5",
    style: {
      enableBackground: "new 0 0 340.2 412.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t\t.st0{fill:#003045;}\n\t\t.st1{fill:#89BAD6;}\n\t\t.st2{fill:#FFFFFF;}\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 253.2,
    className: "st0",
    width: 340.2,
    height: 105.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    className: "st1",
    width: 340.2,
    height: 249.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "138.5,189.9 157,202 157,118.8 201.7,147.8 201.7,106.6 138.5,65.5   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "63.3,197.7 63.3,153.5 106.3,125.5 106.3,30.2 30.2,79.7 30.2,219.2   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "208.9,101.9 208.9,181.7 238,200.5 238,40.1 175.9,80.4   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "113.4,30.2 113.4,165.2 131.4,153.5 131.4,60.9 131.4,41.9   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "259.5,110.2 245.1,119.6 245.1,195.9 259.5,186.5 309.9,219.2 309.9,142.6   "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "0,362.8 75.6,412 75.6,362.8  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.2,277.5h6.2c7.3,0,11.6,2.9,11.6,11s-5.3,11-11.6,11h-6.2V277.5z M36.5,295.7c5.6,0,7.3-2.2,7.3-7.2     c0-5-1.7-7.5-7.3-7.5h-2v14.6H36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.9,277.5h4.3v21.9h-4.3V277.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.5,291.2h-0.2v8.2H61v-21.9h6.2c5.1,0,8.6,1.8,8.6,6.5c0,3.7-2.3,6.2-5.8,7l7.5,8.5h-5.1L65.5,291.2z      M67.2,288.2c2.7,0,4.3-1.3,4.3-3.8c0-2.5-1.6-3.5-4.3-3.5h-1.9v7.4H67.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80,277.5h14v3.6h-9.7v5.3h6.5v3.4h-6.5v6H94v3.6H80V277.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.8,277.5h4.3v9.8l8.7-9.8h4.4l-7.9,8.7l8.4,13.2h-4.8l-6.2-10.2l-2.6,2.8v7.4h-4.3V277.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M122.8,281.1h-6.3v-3.6h16.8v3.6H127v18.3h-4.3V281.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M134.7,288.4c0-7.6,5.4-11.5,10.8-11.5c6.4,0,10.8,3.9,10.8,11.5c0,7.6-5.4,11.5-10.8,11.5     C139.1,299.9,134.7,296,134.7,288.4z M151.9,288.6c0-5.2-2.5-8-6.5-8c-3.9,0-6.5,2.8-6.5,7.7c0,5.2,2.5,8.1,6.5,8.1     C149.4,296.3,151.9,293.5,151.9,288.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M164.4,291.2h-0.2v8.2h-4.3v-21.9h6.2c5.1,0,8.6,1.8,8.6,6.5c0,3.7-2.3,6.2-5.8,7l7.5,8.5h-5.1L164.4,291.2z      M166.2,288.2c2.7,0,4.3-1.3,4.3-3.8c0-2.5-1.5-3.5-4.3-3.5h-1.9v7.4H166.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184.5,279.7l-0.8-2.2h4.4l8.6,21.9h-4.5l-1.7-4.5h-8.1l-1.7,4.5h-4.1L184.5,279.7z M183.6,291.7h5.8l-2.3-6     l-0.6-1.9l-0.6,1.9L183.6,291.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M201.7,281.1h-6.3v-3.6h16.8v3.6h-6.3v18.3h-4.3V281.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M215.3,277.5h14v3.6h-9.7v5.3h6.5v3.4h-6.5v6h9.7v3.6h-14V277.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M237.7,281.1h-6.3v-3.6h16.8v3.6H242v18.3h-4.3V281.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30.2,312.9H44v3.6h-9.5v5.5h6.2v3.3h-6.2v9.6h-4.3V312.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.6,323.9c0-7.6,5.4-11.5,10.8-11.5c6.4,0,10.8,3.9,10.8,11.5c0,7.6-5.4,11.5-10.8,11.5     C50,335.3,45.6,331.4,45.6,323.9z M62.8,324c0-5.2-2.5-8-6.5-8c-3.9,0-6.5,2.8-6.5,7.7c0,5.2,2.5,8.1,6.5,8.1     C60.3,331.7,62.8,328.9,62.8,324z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.3,326.7h-0.2v8.2h-4.3v-21.9H77c5.1,0,8.6,1.8,8.6,6.5c0,3.7-2.3,6.2-5.8,7l7.5,8.5h-5.1L75.3,326.7z      M77,323.7c2.7,0,4.3-1.3,4.3-3.8c0-2.5-1.5-3.5-4.3-3.5h-1.9v7.4H77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M97.6,312.9h6.5c6,0,8.5,2,8.5,5.5c0,3-1.7,4.5-4.1,5.1v0.1c2.6,0.5,4.5,1.7,4.5,5.1c0,3.5-2.5,6.2-8.6,6.2     h-6.7V312.9z M104.3,321.9c3.2,0,4.1-1.1,4.1-2.9c0-1.8-1.2-2.6-4.1-2.6h-2.4v5.5H104.3z M104.4,331.3c3.2,0,4.3-1.1,4.3-3     c0-1.9-1.1-3-4.3-3h-2.6v6H104.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.2,325.8l-7.2-12.9h4.7l4.8,9.2l4.9-9.2h4.2l-7.2,12.9v9h-4.3V325.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133,323.9c0-7.6,4.8-11.5,10.7-11.5c3.6,0,5.7,1.1,6.9,2.1v4.8c-1.2-1.9-3.2-3.3-6.4-3.3     c-4.4,0-6.9,2.7-6.9,7.7c0,5,2.4,8.3,6.3,8.3c1,0,2-0.1,2.7-0.4v-6.8h4.3v8.8c-1.5,1-3.9,1.8-7.2,1.8     C137.3,335.3,133,331.5,133,323.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.8,323.9c0-7.6,4.8-11.5,10.7-11.5c3.6,0,5.7,1.1,6.9,2.1v4.8c-1.2-1.9-3.2-3.3-6.4-3.3     c-4.4,0-6.9,2.7-6.9,7.7c0,5,2.4,8.3,6.3,8.3c1,0,2-0.1,2.7-0.4v-6.8h4.3v8.8c-1.5,1-3.9,1.8-7.2,1.8     C158,335.3,153.8,331.5,153.8,323.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.7,312.9h4.3v9.8l8.7-9.8h4.4l-7.9,8.7l8.4,13.2h-4.8l-6.2-10.2l-2.6,2.8v7.4h-4.3V312.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M193.8,312.9h4.4l5.2,15.4h0.1l5.3-15.4h4.1l-7.9,21.9h-3.5L193.8,312.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.3,315.1l-0.8-2.2h4.4l8.6,21.9h-4.5l-1.7-4.5h-8.1l-1.7,4.5h-4.1L219.3,315.1z M218.4,327.1h5.8l-2.3-6     l-0.6-1.9l-0.6,1.9L218.4,327.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M234.1,312.9h4.3v18.3h8.2v3.7h-12.4V312.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M249.7,312.9h4.3v21.9h-4.3V312.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.4,316.5h-6.3v-3.6h16.8v3.6h-6.3v18.3h-4.3V316.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277,312.9h14v3.6h-9.7v5.3h6.5v3.4h-6.5v6h9.7v3.6h-14V312.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M299.4,316.5h-6.3v-3.6h16.8v3.6h-6.3v18.3h-4.3V316.5z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDibk);
export default __webpack_public_path__ + "static/media/dibk.dd109f9eb44308cc78423717b19416cf.svg";
export { ForwardRef as ReactComponent };